import React, { Component } from 'react';
import { connect } from 'react-redux';
import { resetStore } from '../../../actions/actionCreator';
import { logOutUser } from '../../../actions/auth';
import { aemHostClient, eapiClient } from '../../../restClient';
import { setTranslatedData } from '../../layouts/actions/actionCreator';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../Modal';
//import {Pagejson} from './json_session-page';
import moment from 'moment';
import { Translations, decryptData, electOwningCase, isEmpty } from '../../../utils';

class Notification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      countdown: 120,
      countdownStart: null
    }
  }

  componentWillMount() {

  }

  appLogout = () => {
    const buildName = process.env.REACT_APP_BUILD;
    if (buildName === 'customer') {
      this.props.history.push('/login');
      this.props.resetInterval();
    }
    else {
      this.props.history.push('/logout');
    }
    this.props.resetStore(null);
    this.props.logOutUser();
    if (this.props.history.location.pathname === '/staff-login' || this.props.history.location.pathname === '/logout') {
      this.props.resetInterval();
      // aemHostClient('/aemData/formData/json_en-gb')
      // .then(({data}) => {
      //   this.props.setTranslatedData(data);
      //
      // })
    }
    //   }
    // })

    // .catch(error => {
    //   this.props.resetStore(null);
    //   this.props.logOutUser();
    // });
  }
  componentWillReceiveProps(nextProps) {
    // if (this.props.timeoutModel !== nextProps.timeoutModel) {
    //   this.setState({
    //     showModal: nextProps.timeoutModel
    //   }, () => { })
    // }
    if (this.oneMinuteTimer) {
      clearTimeout(this.oneMinuteTimer);
    }
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    const countdownSeconds = 300;
    const startTime = Date.now();
    this.setState({
      showModal: nextProps.timeoutModel,
      countdown: countdownSeconds,
      countdownStart: startTime
    }, () => {
      if (this.countdownInterval) clearInterval(this.countdownInterval);
      this.countdownInterval = setInterval(() => {
        const elapsed = Math.floor((Date.now() - this.state.countdownStart) / 1000);
        const remaining = countdownSeconds - elapsed;
        if (remaining <= 0) {
          clearInterval(this.countdownInterval);
          window.localStorage.clear();
          window.sessionStorage.clear();
          if (nextProps.timeoutModel) {
            window.location.href = '/logout';
          }
          this.setState({ countdown: 0 });
        } else {
          this.setState({ countdown: remaining });
        }
      }, 1000);
    });

    if (!window.location.pathname.includes('logout')) {
      // if (this.props.staticHeading !== nextProps.staticHeading) {
      aemHostClient("/aemData/formData/json_session-page")
        .then(({ data }) => {
          this.setState({ pageJson: data.par })
        });
      // }
    }

    if (nextProps.minutes === 4) {
      this.props.stopInterval();
      this.intervalID = setInterval(() => {
        var now = moment(new Date())
        var end = moment(nextProps.cookie);
        var milliSeconds = end.diff(now);
        var tempTime = moment.duration(milliSeconds);
        var y = `${tempTime.minutes()} min ${tempTime.seconds()} secs`;
        var seconds = tempTime.seconds();
        var minutes = tempTime.minutes();
        this.setState({
          curTime: y
        })
        if ((minutes === 0 && seconds === 0) || (minutes < 0 || seconds < 0)) {
          if (!isEmpty(this.props.cases)) {
            this.exitCaseApi()
          } else {
            // this.appLogout();
          }
          this.setState({
            showModal: false
          })
          clearInterval(this.intervalID);
        }
      }, 1000)
      this.setState({
        intervalID: this.intervalID
      })
    }
  }

  exitCaseApi = async () => {
    let caseId = this.props.owningCase && this.props.owningCase.caseId;
    let tab = '';
    if (caseId === undefined || caseId === null) {
      caseId = window.localStorage.getItem('owningCase');
    }
    let tabValue = window.localStorage.getItem("tab");
    if (tabValue !== undefined && tabValue !== null && tabValue !== '') {
      tab = await decryptData(tabValue,);
    }
    const pageUrl = window.location.pathname;
    let apiURL = "/cases/" + caseId + '/exitCase';
    var METHOD = 'PUT';
    eapiClient(apiURL, {
      method: METHOD,
      timeout: 100000,
      data: { pageUrl: pageUrl, event: "Session timeout", tab: tab }
    })
      .then(({ data }) => {
        window.localStorage.removeItem('owningCase');
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('customer');
        window.localStorage.removeItem('tab');
        // this.appLogout();
      });
  }

  toggleDialog = () => {
    this.setState(prevState => ({
      showModal: !prevState.showModal
    }))
    clearInterval(this.state.intervalID);
    this.props.history.push('/case-list');
    this.props.startInterval();
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  editingBtn = () => {
    clearInterval(this.state.intervalID);
    eapiClient("/users/updateToken")
      .then(({ data }) => {
        if (this.props.customer.roleDetails.customer) {
          eapiClient('/customers/sessions', {
            method: 'POST',
            data: JSON.stringify({})
          })
            .then(({ data }) => {
              this.props.startInterval();
            });
        }
        else {
          this.props.startInterval();
        }
      })
    this.setState(prevState => ({
      showModal: !prevState.showModal
    }))

  }
  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  render() {
    return (
      <div>
        {this.state.pageJson !== undefined ?
          <Modal
            show={this.state.showModal}
            onClose={this.toggleDialog}
            removeDialogCloseHandlers='false'
          >
            <ModalHeader
              title={this.translations(this.state.pageJson.page_title_mainTitle.pageHeading)}
            />
            <ModalBody>
              {this.translations(this.state.pageJson.page_title_mainTitle.descriptionText)}
              <div style={{ textAlign: 'center', fontSize: '0.875rem' }}>
                <span>{this.translations(this.state.pageJson.modal_sessionCase.text)}</span>
                <p>{this.state.countdown > 0
                  ? `  ${Math.floor(this.state.countdown / 60)} min ${String(this.state.countdown % 60).padStart(2, '0')} sec`
                  : ''}</p>
              </div>
            </ModalBody>
            <ModalFooter>
              <button
                className="gdocs-btn-primary"
                onClick={this.editingBtn}
                onKeyDown={this.editingBtn}
                tabindex="0"
              >
                Continue Editing
              </button>
            </ModalFooter>
          </Modal>

          : ''}
      </div>
    )
  }
}
const mapStateToProps = state => {
  return {
    lang: state.lang,
    customer: state.auth.userDetails,
    cases: state.cases,
    owningCase: electOwningCase(state.cases)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    logOutUser: () => {
      dispatch(logOutUser());
    },
    resetStore: () => {
      dispatch(resetStore());
    },
    setTranslatedData: translatedData => {
      dispatch(setTranslatedData(translatedData))
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Notification);


// WEBPACK FOOTER //
// ./src/components/common/Notification/index.js